import { ReactElement, SVGProps } from 'react';
import BaseIcon from "./BaseIcon";

const EditNoteIcon = (props: SVGProps<any>): ReactElement => {
  return (
    <BaseIcon {...props}>
      <path d="M0 15V12h9.334v3zm0 -6V6h14.666v3zm0 -6V0h14.666v3zM12 24v-4.613l7.367 -8.25q0.3 -0.337 0.666 -0.487t0.734 -0.15q0.4 0 0.766 0.168 0.367 0.169 0.667 0.506l1.234 1.388q0.266 0.337 0.416 0.75a2.4 2.4 0 0 1 0.15 0.824q0 0.414 -0.133 0.844 -0.133 0.432 -0.433 0.769L16.1 24zm8.767 -8.4 1.232 -1.463 -1.232 -1.387 -1.267 1.426z" fill="currentColor" />
    </BaseIcon >
  )
}
export default EditNoteIcon;